import { getBookingURLByLeadOrigin } from '~src/constants';
import { useDisplayContext } from '~src/context/DisplayContext';
import { useAnalytics } from '~src/tracking/ga';
import { useNavigation } from './useNavigation';

export const useNavigateToAdvisorBooking = () => {
  const { leadOrigin } = useDisplayContext();

  const { navigate } = useNavigation();

  const { trackEvent } = useAnalytics();

  // The mapping moved to ~src/constants so the calculator header shares it. It
  // used to live here, privately, while the header did its own edc-or-Bodil
  // check — which is how /jyskebank and /nordea ended up linking to neither.
  const targetURL = getBookingURLByLeadOrigin(leadOrigin);
  return () => {
    trackEvent('estimate_page_go_to_booking');

    navigate(targetURL);
  };
};
